import React from 'react';
import classnames from 'classnames';

import styles from './notification-badge.module.scss';

export type NotificationBadgeType = {
  value?: number;
  variant?: '200' | '300';
  className?: string;
};

const getDisplayedContent = (value?: number) => {
  if (!value && value !== 0) {
    return;
  }

  if (value > 99) {
    return '99+';
  }

  return value;
};

export const NotificationBadge: React.FC<NotificationBadgeType> = ({ className, value, variant = '300' }) => {
  const classes = classnames(
    styles.notificationBadge,
    { [styles.hasValue]: value || value === 0 },
    styles[`s${variant}`],
    className
  );

  return (
    <div className={classes} data-testid="notification-badge-component">
      {getDisplayedContent(value)}
    </div>
  );
};
